export const integraciones = {
    text1: "Intégrations.",
    text2: "Contactez les développeurs pour réaliser une intégration avec votre",
    text3: "PMS",
    text4: "Contacter",
    text5: "Demander une intégration",
    text6: "Données collectées",
    text7: "Informations du demandeur",
    text8: "Nom",
    text9: "Motif de la demande",
    text10: "Indiquez la raison pour laquelle vous avez besoin de l'intégration",
    text11: "Fermer",
    text12: "Envoyer la demande d'intégration",
    text13: "Enregistré correctement",
    text14: "Erreur de requête",
};